import { gql, useQuery } from '@apollo/client';

export const APPLICATION_TITLE_LOCALE_FIELDS = gql`
  fragment ApplicationFields on Application {
    id
    topicId
    titleLocales {
      de
      en
    }
  }
`;

export const GET_APPLICATION_TITLE_LOCALES = gql`
  ${APPLICATION_TITLE_LOCALE_FIELDS}
  query GetApplications {
    getApplications {
      ...ApplicationFields
    }
  }
`;

export interface Application {
  id: string;
  topicId?: string;
  titleLocales: {
    de?: string;
    en?: string;
  };
}

export interface GetApplicationsResult {
  getApplications: Application[];
}

export function useApplicationTitleLocalesQuery(skip?: boolean) {
  const { data, loading, error, refetch } = useQuery<GetApplicationsResult>(GET_APPLICATION_TITLE_LOCALES, {
    fetchPolicy: 'network-only',
    notifyOnNetworkStatusChange: true,
    skip: skip ?? false,
  });

  // Convert array to indexed object for easy lookup by ID
  let applicationTitleLocalesData: { [key: string]: Application } = {};

  if (data?.getApplications) {
    applicationTitleLocalesData = data.getApplications.reduce((acc, app) => {
      acc[app.id] = app;
      return acc;
    }, {} as { [key: string]: Application });
  }

  return {
    applicationTitleLocalesData,
    rawApplications: data?.getApplications || [],
    loading,
    error,
    refetch,
  };
}